import type { Location } from 'react-router';
import { useBlocker } from 'react-router';
import { useCheckRuleChanges } from '../utils/useValidate';
import type { GoogleRuleDetails } from '../google/types';
import type { RuleEntry } from '../types';

interface IProps {
  isDirty: boolean;
  isRead: boolean;
  rule: RuleEntry | GoogleRuleDetails;
}

const useRuleBlocker = ({ rule, isDirty, isRead }: IProps) => {
  const checkRuleChanges = useCheckRuleChanges();

  const blocker = useBlocker(
    ({
      currentLocation,
      nextLocation,
    }: {
      currentLocation: Location;
      nextLocation: Location<{ skipBlocker?: boolean }>;
    }) => {
      if (isRead) return false;

      const { skipBlocker } = { ...nextLocation.state };

      const ruleChanges = checkRuleChanges({
        rule,
        isBasicFormDirty: isDirty,
      });
      return !skipBlocker && ruleChanges && currentLocation.pathname !== nextLocation.pathname;
    }
  );

  return blocker;
};

export default useRuleBlocker;
